export const environment = {
  production: true,
  pre: false,
  qa: false,
  module: "gscc-portals",
  portalTitle: "GI GSCC Landing Portal",
  basePath: "https://gslp-bff.prod.gitobaccotracing.com",
  landingPortal: "https://gslp-fr.prod.gitobaccotracing.com",
  dashboardPath: "",
  quicksighhtId: "mockId-xxxx-xxxx-xxxx-xxxx",
  portalVersion: "1.0.1"
};
